const fetchDnsData = async (count: number) => {
  const requests = []

  for (let i = 0; i < count; i++) {
    const random_id = window.crypto.randomUUID()
    const url = `//${random_id}.dns-discovery-prod.spacecowmedia.com`

    const request = fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Request failed with status: ${response.status}`)
        }
        return response.json() // Parse the response as JSON
      })
      .catch((err) => {
        console.error(`Request for ${random_id} failed:`, err)
        return null // Handle any request failure
      })

    requests.push(request)
  }

  // Wait for all requests and filter out failed ones
  const results = await Promise.all(requests)
  const successfulResults = results.filter((result) => result !== null)

  return successfulResults
}

const shuffle = (array: string[]) => {
  let currentIndex = array.length

  // While there remain elements to shuffle...
  while (currentIndex != 0) {
    // Pick a remaining element...
    const randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex--

    // And swap it with the current element.
    ;[array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]]
  }
}

const checkImageDomains = async () => {
  const imageSources = [
    'https://edhrec.com/articles/wp-content/uploads/2024/09/test-image-do-not-delete.png',
    'https://edhrecstatic.com/articles/wp-content/uploads/2024/09/test-image-do-not-delete.png',
    'https://cards.scryfall.io/small/front/6/9/695ccac5-c87e-49af-9131-8f1730e84bc0.jpg',
    'https://json.edhrec.com/test-image-do-not-delete.png',
    'https://json.edhrecstatic.com/test-image-do-not-delete.png',
    'https://edhrecstaticjson.com/test-image-do-not-delete.png',
    'https://edhrecstaticjson2.com/test-image-do-not-delete.png',
  ]
  shuffle(imageSources)

  // A promise that resolves or rejects based on image loading status
  const checkImage = (src: string, retries = 2): Promise<null | { error: string; error2: string; src: string }> =>
    new Promise((resolve) => {
      const img = new Image()

      img.onload = () => resolve(null) // Success, resolve null for no failure

      img.onerror = (errorEvent) => {
        console.log('Error loading image:', src, errorEvent, 'Retries left:', retries)
        if (retries > 0) {
          // Retry with a reduced retry count after delay
          setTimeout(() => {
            resolve(checkImage(src, retries - 1))
          }, 500)
        } else {
          // Capture detailed error info after retries are exhausted
          resolve({
            // Stringified error objects
            error: JSON.stringify(errorEvent),
            error2: JSON.stringify(errorEvent, Object.getOwnPropertyNames(errorEvent)),
            // The image source
            src,
          })
        }
      }

      // Start loading the image
      img.src = src
    })

  // Check all images and gather results
  const results = await Promise.all(imageSources.map((src) => checkImage(src)))

  // Filter only the failed images that returned error objects
  const failed = results.filter((result) => result !== null)

  // If any images failed, send a POST request with the detailed errors
  if (failed.length > 0) {
    const dnsData = await fetchDnsData(4)

    fetch('/api/cloudflareerror/', {
      body: JSON.stringify({
        dns: dnsData,
        error: 'Failed to load images',
        fetchErrors: failed,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
    }).catch((err) => {
      console.error('Failed to send error report:', err)
    })
  }
}

export default checkImageDomains
